import React from 'react';

const SvgHt = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="HT_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="HT_svg__d">
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#F0F0F0" offset="100%" />
      </linearGradient>
      <rect id="HT_svg__c" x={0} y={0} width={9.333} height={8} rx={0.667} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="HT_svg__b" fill="#fff">
        <use xlinkHref="#HT_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#HT_svg__a" />
      <path fill="#112EBC" mask="url(#HT_svg__b)" d="M0 0h28v9.333H0z" />
      <path fill="#E3264A" mask="url(#HT_svg__b)" d="M0 9.333h28V20H0z" />
      <g mask="url(#HT_svg__b)">
        <g transform="translate(9.333 6.667)">
          <mask id="HT_svg__e" fill="#fff">
            <use xlinkHref="#HT_svg__c" />
          </mask>
          <use fill="url(#HT_svg__d)" xlinkHref="#HT_svg__c" />
          <path
            d="M.333 6.873v.794H9v-.794l-1.29-.645c-.608-.305-1.694-.561-2.375-.561H3.999c-.688 0-1.762.254-2.376.56l-1.29.646z"
            stroke="#366C14"
            strokeWidth={0.667}
            fill="#AABCAE"
            mask="url(#HT_svg__e)"
          />
          <circle
            fill="#D4B872"
            mask="url(#HT_svg__e)"
            cx={4.667}
            cy={3.333}
            r={2}
          />
          <path
            d="M1.667 4.027v1.965a.34.34 0 0 0 .33.341h5.34a.34.34 0 0 0 .33-.34V4.026L5.396 5.844a1.212 1.212 0 0 1-1.458 0L1.667 4.027z"
            stroke="#0D3488"
            strokeWidth={0.667}
            fill="#C28321"
            mask="url(#HT_svg__e)"
          />
          <path
            d="M2.896 1.563c-.127-.127-.077-.23.112-.23h3.318c.188 0 .233.108.111.23l-1.54 1.54a.329.329 0 0 1-.46 0l-1.54-1.54z"
            fill="#216C30"
            mask="url(#HT_svg__e)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgHt;
